import getLogger from '@ignitesales/logger-es';
// Import mock page data
import { mockPages } from './mockPageData.mjs';

const logger = getLogger();

const mockUUID = '54321ign9it3e';
// Use imported mock pages as default
let pages = mockPages;

let currentPageIndex = 0;

const wait = (ms) => {
  const time = ms || Math.random() * 1000;
  return () => new Promise((resolve) => setTimeout(resolve, time));
};

const buildPageResolutionService = (config = {}) => {
  const { guideDelivery, guideType, optsForMock } = config;

  return {
    ready: false,
    nextPage: async (request) => {
      logger.info('entered pageResolutionService.nextPage()', {
        currentPageIndex,
        request,
      });

      const localAnswers = JSON.parse(window.sessionStorage.getItem(`${mockUUID}-localAnswers`)) || {};
      const localAnswersArray = [];
      /* eslint-disable-next-line no-unused-vars */
      for (let [key, value] of Object.entries(localAnswers)) {
        localAnswersArray.push(value);
      }
      let reverse = request.reverse;

      await wait();
      switch (request.page.type) {
        case 'landing':
          reverse = false;
          break;

        case 'summary':
          reverse = true;
          break;

        default:
          break;
      }

      if (reverse) {
        currentPageIndex--;
      } else {
        currentPageIndex++;
      }

      return {
        ...pages[currentPageIndex],
        answers: localAnswersArray
      };
    },

    loadPage: async (request) => {
      logger.info('loadPage', request);
      switch (request.page.type) {
        case 'landing':
          break;

        case 'summary': {
          const summaryIndex = pages.findIndex((p) => p.type === 'summary');
          currentPageIndex = summaryIndex > 0 ? summaryIndex : 0;
          break;
        }

        case 'details': {
          const detailsIndex = pages.findIndex((p) => p.type === 'details');
          currentPageIndex = detailsIndex > 0 ? detailsIndex : 0;
          break;
        }

        case 'survey': {
          const path = request.page.path.key;
          const page = request.page.page.key;
          const pageIndex = pages.findIndex((p) => {
            return (
              p.type === 'survey' &&
              p.page.path.key === path &&
              p.page.page.key === page
            );
          });
          if (pageIndex > 0) {
            currentPageIndex = pageIndex;
          } else {
            currentPageIndex = 0;
          }
          break;
        }

        default:
          currentPageIndex = 0;
          break;
      }

      return pages[currentPageIndex];
    },

    loadMessages: async () => {
      return {
        mockServerMessage: 'This message would come from the backend service'
      };
    },

    initializeUser: async () => {
      return {
        uuid: mockUUID,
        guideId: 100,
        guideDelivery: guideDelivery || 'online',
        guideType: guideType || 'consumer',
        isRemoteSession: optsForMock.isRemoteSession || false,
        assignment: {
          employee: {
            firstName: 'Darth',
            lastName: 'Vader',
          },
          branch: {
            name: 'Skywalker Lane',
          },
        },
      };
    },
  };
};

const pageResolutionService = buildPageResolutionService();

const setPages = (newPages) => {
  pages = newPages;
  if (pageResolutionService) {
    pageResolutionService.ready = true;
  }
};

export {
  pageResolutionService as default,
  pageResolutionService,
  buildPageResolutionService,
  mockUUID,
  setPages,
};
